import { render } from "./Index.vue?vue&type=template&id=0e7adf02"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/ItemAssets/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e7adf02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e7adf02', __exports__)) {
    console.log('reload')
    api.reload('0e7adf02', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=0e7adf02", () => {
    console.log('re-render')
    api.rerender('0e7adf02', render)
  })

}


export default __exports__